// "Check your email" — the magic-link handoff. The user sets their password via the
// existing claim flow; the trial does not start here.
import type { Answers } from '../lib/session';
import { PrimaryButton } from '../components/ui';

const TRIAL_DAYS = Number(import.meta.env.VITE_TRIAL_DAYS || 7);
// Same support page the Result screen links to.
const SUPPORT_URL = 'https://expyhealth.com/support';

export function CheckEmail({ answers, onContinue }: { answers: Answers; onContinue: () => void }) {
  const email = (answers.email as string) || 'your email';
  return (
    <div style={{ minHeight: '100vh', background: 'var(--surface)', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 24 }}>
      <div style={{ maxWidth: 460, textAlign: 'center' }}>
        <div style={{ width: 64, height: 64, borderRadius: 18, background: 'var(--teal-tint)', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 22px' }}>
          <svg width={30} height={30} viewBox="0 0 24 24" fill="none" aria-hidden>
            <rect x={3} y={5} width={18} height={14} rx={3} stroke="var(--teal-deep)" strokeWidth={1.8} />
            <path d="M4 7l8 6 8-6" stroke="var(--teal-deep)" strokeWidth={1.8} strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        </div>
        <div style={{ fontSize: 30, fontWeight: 800 }}>Check your email.</div>
        <div className="pretty" style={{ fontSize: 16, fontWeight: 500, color: 'var(--slate)', marginTop: 12, lineHeight: 1.55 }}>
          We sent a sign-in link to <strong style={{ color: 'var(--ink)' }}>{email}</strong>. Open it on your phone. That’s where your plan lives.
        </div>
        <div style={{ fontSize: 14, fontWeight: 700, color: 'var(--teal-deep)', marginTop: 16 }}>
          Your {TRIAL_DAYS} days start when you open the app, not a minute before.
        </div>
        <div style={{ marginTop: 26 }}>
          <PrimaryButton onClick={onContinue}>Get the app</PrimaryButton>
        </div>
        {/* The invite is minted once, at account creation, and the API has no resend
            endpoint, so this is guidance rather than a button that does nothing. */}
        <div style={{ fontSize: 13, fontWeight: 600, color: 'var(--slate)', marginTop: 16, lineHeight: 1.5 }}>
          Did not get it? Check your spam folder. If it is still missing, contact support at{' '}
          <a href={SUPPORT_URL} target="_blank" rel="noreferrer" style={{ color: 'var(--teal-deep)', fontWeight: 800 }}>expyhealth.com/support</a>.
        </div>
      </div>
    </div>
  );
}
